import { LoadingOutlined } from '@ant-design/icons';
import { Spin, TreeSelect } from "antd";
import { DataNode } from "antd/es/tree";
import { useEffect, useState } from "react";
import { arrayCommon } from '../../helpers/common';
import { DonViResponse } from '../../models/donvi/DonVi';
import { layDanhSachDonViPhuTrachTreeView, layDanhSachDonViTreeView } from '../../services/donvi';

const convertDataTreeView = (data: any): DataNode[] => {
    if (!data) return [];

    return data.map((_item: any) => ({
        value: _item?.id, 
        title: _item?.ten,
        children: convertDataTreeView(_item?.children)
    }));
};

interface Props {
    showHeader?: boolean;
    donViQuanLy?: boolean;
    treeProps?: any;
    value?: number; 
    isKPI?: boolean,
    loaiPhuTrach?: number; 
    onChange: (e: any) => void;
}

const ContainerDonViPhuTrach = ({
    showHeader,
    donViQuanLy,
    treeProps,
    value,
    isKPI,
    loaiPhuTrach,
    onChange 
}: Props) => {

    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [dsDonVi, setDsDonVi] = useState<Array<DonViResponse>>([]);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);

    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    // Chỉ hiển thị value khi đơn vị đó thực sự tồn tại trong danh sách
    const selectedValue = value && arrayCommon.findById(dsDonVi, value) ? value : undefined;

    const layDsDonViPhuTrach = async () => {
        try {
            setLoadingTree(true);

            const data = donViQuanLy ? await layDanhSachDonViTreeView(isKPI) : await layDanhSachDonViPhuTrachTreeView(loaiPhuTrach);
            setDsDonVi(data ?? []);
            setTreeData(convertDataTreeView(data));
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingTree(false);
        }
    };
    
    useEffect(() => {
        layDsDonViPhuTrach();
    }, []);

    return (
            loadingTree ? (
                <Spin indicator={antIcon} />
            ) : (
                <TreeSelect
                    {...treeProps}
                    showSearch
                    value={selectedValue}
                    treeData={treeData}
                    placeholder="--Chọn đơn vị, phòng ban--"
                    notFoundContent="Không có đơn vị, phòng ban"
                    treeDefaultExpandAll
                    style={{ width: "100%", height: "35px" }}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    loading={loadingTree}
                    filterTreeNode={(search, item: any) =>
                        item.title.toLowerCase().includes(search.toLowerCase())
                    }
                    onChange={(val: string) => {
                        if (!val) {
                            onChange(null);
                            return;
                        }

                        const numberVal = Number(val);

                        const dv = arrayCommon.findById(dsDonVi, numberVal);
                        onChange(dv);
                    }}
                />
            )
    );
};

export default ContainerDonViPhuTrach;